<template>
  <div>
    <v-form
      class="d-flex flex-wrap justify-space-between align-center ga-6"
      @submit.prevent="$emit('submit')"
    >
      <div
        v-for="(value, key) in form.values"
        :key="key"
        class="flex-grow-1 account-form-field"
      >
        <div
          v-if="!showUpdateButton"
          class="account-read-only-field"
        >
          <label class="form-label-text">
            {{ form.labels[key] }}
          </label>
          <p class="text-body-1 text-textDarkest mb-0 mt-1">
            {{ value }}
          </p>
        </div>
        <DpplFormField
          v-else
          :field-name="key"
          :form="form"
          v-bind="$attrs"
        >
          <template #field="{ props, on }">
            <DpplTextField
              :label="form.labels[key]"
              v-bind="props"
              :disabled="key === 'email'"
              v-on="on"
            />
          </template>
        </DpplFormField>
      </div>
      <AccountEditPersona class="flex-grow-1" />
      <div
        v-if="showUpdateButton"
        class="ml-auto mt-auto"
      >
        <DpplAutoSizedButton
          :disabled="!isValid"
          @click="$emit('submit')"
        >
          Update
        </DpplAutoSizedButton>
      </div>
    </v-form>
  </div>
</template>

<script>
import DpplAutoSizedButton from '@/components/datapeople/DpplAutoSizedButton.vue';
import DpplTextField from '@/components/datapeople/DpplTextField.vue';
import DpplFormField from '@/components/datapeople/DpplFormField.vue';
import { mapActions } from 'pinia';
import { useModals } from '@/stores/modals/modals';
import AccountEditPersona from '@/components/settings/account/AccountEditPersona.vue';

export default {
  name: 'AccountForm',
  components: {
    DpplAutoSizedButton,
    DpplFormField,
    DpplTextField,
    AccountEditPersona,
  },
  props: {
    form: { type: Object, default: () => ({}) },
    isValid: { type: Boolean, default: false },
    showUpdateButton: { type: Boolean, default: false },
  },
  emits: ['submit'],
  methods: {
    ...mapActions(useModals, ['setModal']),
  },
};
</script>

<style scoped lang="less">
:deep(.v-input) {
  color: @text-lighter;
}

:deep(.v-field--disabled) {
  opacity: 1;
}

.account-form-field {
  flex: 1;

  &:not(:last-child) {
    margin-right: 24px;
  }
}
</style>
